import React from 'react';
import DeleteIcon from '../../assets/svg/metaEdit/detete_meta.svg';

const DeleteRowButton = ({ onClick }) => (
  <button onClick={onClick} className="meta-delete">
    <img src={DeleteIcon} style={{ width: 20 }} alt="delete" />
  </button>
);

export default DeleteRowButton;